import axios from 'axios';
import apisUrls from '../urls';

const deleteCountryApi =  (id) => {
  return axios.delete(`${apisUrls?.deleteCountry}?country_id=${id}`);
};

export default deleteCountryApi;
